import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function deleteWidget(token, params) {
    return Api.delete(REQUEST_URLS.COMPANY_APPROVAL.DELETE_WIDGET, {
        params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default deleteWidget;